<template>
    <div v-if="companyMissing" class="company-alert">
        <div class="company-alert__head">
            <span class="company-alert__icon">
                <v-icon size="18" color="error">mdi-alert-decagram-outline</v-icon>
            </span>
            <span class="company-alert__text">
                {{ $t('company.company_unavailable') }} {{ $t('company.become_independent_question') }}
            </span>
        </div>
        <div class="text-center">
            <v-btn depressed small color="primary" class="company-alert__btn black--text" @click="$refs.confirm.show()">
                {{ $t('company.become_independent') }}
            </v-btn>
        </div>

        <kimsa-confirm ref="confirm" :title="$t('company.become_independent_confirm_title')"
            :content="$t('company.become_independent_confirm_body')" :alert-mode="true" :loading="loading"
            :close-on-confirm="false" @confirm="becomeIndependent" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { db } from '@/utils/Firebase'
import KimsaConfirm from '@/components/common/KimsaConfirm.vue'

export default {
    name: 'CompanyUnavailable',
    components: { KimsaConfirm },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState(['companyMissing'])
    },
    methods: {
        async becomeIndependent() {
            const vm = this
            vm.loading = true
            try {
                await db.collection('users').doc(vm.currentUser.uid).update({
                    accountType: 'coach',
                    coachSubscription: null
                })
                await vm.waitForAccountType('coach')
                vm.$refs.confirm?.hide()
                vm.replaceRoute({ name: vm.paymentsEnabled ? 'coach.credit-card' : 'coach.home' })
            } catch (e) {
                console.log('becomeIndependent error', e)
            } finally {
                vm.loading = false
            }
        },
        waitForAccountType(type, timeout = 5000) {
            const vm = this
            return new Promise(resolve => {
                const start = Date.now()
                const check = () => {
                    if (vm.account?.accountType === type || Date.now() - start > timeout) return resolve()
                    setTimeout(check, 150)
                }
                check()
            })
        }
    }
}
</script>

<style scoped>
.company-alert {
    padding: 14px;
    margin-bottom: 12px;
    border-radius: 12px;
    border: 1px solid rgba(232, 92, 92, .35);
    background: rgba(232, 92, 92, .08);
}

.company-alert__head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
}

.company-alert__icon {
    flex-shrink: 0;
    display: flex;
    margin-top: 1px;
}

.company-alert__text {
    flex: 1;
    min-width: 0;
    font-size: var(--fs-body);
    color: var(--v-txtPrimary-base);
    line-height: 1.45;
}

.company-alert__btn {
    border-radius: 8px !important;
    text-transform: none;
    font-weight: 600;
    letter-spacing: normal;
}
</style>
